// import { useEffect, useState } from 'react';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
// import { useFetchPaycorSettings } from 'hooks/integrations/paycor/useFetchPaycorSettings';

import EarningsMappings from './EarningsMapping';
import EmployeesMapping from './EmployeesMapping';
// import LaborCodesMapping from './LaborCodesMapping';

const MappingTabs = () => {
  const tabHeaders = [{ label: 'Employees' }, { label: 'Earnings code' }];

  // const [tabHeaders, setTabHeaders] = useState(initialTabHeaders);
  const tabPanels = [
    { panel: <EmployeesMapping /> },
    { panel: <EarningsMappings /> },
    // { panel: <LaborCodesMapping /> },
  ];

  // const { data } = useFetchPaycorSettings();

  // useEffect(() => {
  //   const showLaborCodes = data?.payload?.use_labor_codes;

  //   if (!showLaborCodes) {
  //     const tabHeaders = initialTabHeaders.filter(header => header.label !== 'Labor Codes');
  //     setTabHeaders(tabHeaders);
  //   } else {
  //     setTabHeaders(initialTabHeaders);
  //   }
  // }, [data]);

  return (
    <Tabs>
      <TabHeader tabHeaders={tabHeaders} />
      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};
export default MappingTabs;
